import { isDefined } from "@clipboard-health/util-ts";
import { type WorkerRequirement } from "@src/appV2/redesign/Documents/api/types";
import { isBefore, parseISO } from "date-fns";

interface IsRequirementInValidForShiftProps {
  requirement: WorkerRequirement;
  expiryDate?: string;
}

export function isRequirementInValidForShift(props: IsRequirementInValidForShiftProps): boolean {
  const { requirement, expiryDate } = props;

  if (!requirement.isValid) {
    return true;
  }

  return (
    isDefined(expiryDate) &&
    isDefined(requirement.expiry) &&
    isBefore(parseISO(requirement.expiry), parseISO(expiryDate))
  );
}
